export default "{\n    \"label\": \"Escalade\",\n    \"options\": {\n        \"true\": \"Actuellement escaladé\"\n    }\n}\n"